import { twMerge } from "tailwind-merge";

type ErrorProps = {
  error?: string | null;
  className?: string;
};

export const Error = ({ error, className }: ErrorProps) => {
  const classes = twMerge("text-destructive text-sm", className);
  if (!error) return null;
  return <p className={classes}>{error}</p>;
};
